import { h } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';

// Utils
import { calcColumns, stepShowHide } from '../../../utilities/form/formUtils';

// Constants
import { stepComponents } from '../../../constants/Steps';

// Components
import Text from '../../Global/Text';
import Coverage from './Coverage';
import Icon from '../../Global/Icon';
import { getCoverageCodesAndMergeCodes, replaceAll, getOfferEndDate } from '../../../utilities/common';
import { checkConditions } from '../../../utilities/package/packageUtils';

const ProductSummary = ({
  dispatch,
  errors,
  handleSubmit,
  onBlur,
  onChange,
  setValues,
  touched,
  values,
  setFormValues,
  setFieldValue,
  userData,
  initialValues,
  sectionHeader,
  sectionContact,
  sectionCoverage,
  sectionConsent,
  sectionPrice,
  sectionDate,
  sectionSelectStartDate,
  sectionValueOffer,
  sectionVoucher,
  sections,
  sectionsRight,
  translations,
  campaigns,
  packageName,
}) => {
  const formParams = {
    handleSubmit,
    onChange,
    onBlur,
    errors,
    touched,
    setValues,
    values,
    setFormValues,
    dispatch,
    userData,
  };

  const { chosenPackageName, basketList = [] } = userData;
  let { chosenPackage } = userData;
  chosenPackage = chosenPackage || basketList[0];
  const { coverageMerge, coverageList } = initialValues;
  const usedParams = userData.quotes.defaults[chosenPackage].usedParams || {};
  const usedCoverageCode = usedParams.coverageCodes
    || userData.quotes.defaults[chosenPackage].coverageCodes;
  const { campaignCode } = userData.quotes.defaults[chosenPackage];
  const [coverageCodes, coverageCodesMerge] =
    getCoverageCodesAndMergeCodes(
      usedCoverageCode,
      coverageMerge,
      userData
    );
  const { offerDurationLength } = userData.quotes[chosenPackage] || userData.quotes;
  const { offerDurationType } = userData.quotes[chosenPackage] || userData.quotes;
  const { activationDate } = userData;
  const offerEndDate = getOfferEndDate(
    offerDurationLength,
    offerDurationType,
    activationDate
  );
  let campaign = sectionVoucher;
  let campaignIcon = 'voucher';
  let showCampaign = true;
  let valueOfferEnable = false;

  if (!campaign && initialValues.campaign && initialValues.campaign.productSummary) {
    if (initialValues.campaign.showForProducts) {
      showCampaign = initialValues.campaign.showForProducts
        .filter(product => basketList.includes(product)).length > 0;
      showCampaign = showCampaign && (!initialValues.campaign.showForPackages
        || initialValues.campaign.showForPackages.includes(chosenPackage));
    }

    if (showCampaign) {
      campaign = campaign || initialValues.campaign.productSummary;
      campaignIcon = initialValues.campaign.icon || '';
    }
  }
  // Only for Retrieve Offer as we don't known the product to start with.
  if (!packageName && campaigns) {
    campaigns.forEach(camp => {
      // Only activate campaign for current product/package.
      if (camp.isActive && camp.showForProducts.includes(userData.basketList[0])) {
        if (!camp.showForPackages ||
          (camp.showForPackages && camp.showForPackages.includes(chosenPackage))) {
          campaign = camp.componentData.productSummary;
          campaignIcon = camp.icon || '';
        }
      }
    });
  }

  const sectionDateBody = replaceAll(sectionDate.body, translations, userData).split('(')[0];
  const sectionSelectStartDateBody = replaceAll(sectionSelectStartDate, translations, userData);

  const sectionValueOfferBody = replaceAll(sectionValueOffer.body,
    translations, { ...userData, offerEndDate });

  if (campaignCode !== undefined) {
    valueOfferEnable = true;
  }

  const additionalValues = sectionCoverage.additionalValues
    .map(listItem => replaceAll(listItem, translations, userData))
    .filter(listItem => listItem.length > 0);

  return (
    <div className="grid summary">
      <div className="grid__col grid__col--12 grid__col--md-8">
        <div className="summary__outer">
          {sectionHeader &&
          <div className="summary__section summary__header">
            <Text value={sectionHeader.title} className="header__title" component="h5"/>
          </div>
          }

          {sectionContact &&
          <div className="summary__section summary__contact">
            {sectionContact.map(prop => {
              return (
                <div className="summary__contact--inner">
                  <Text value={prop.title} className="header__title" component="div"/>
                  <Text value={prop.body} className="header__title" component="div"/>
                </div>
              );
            })}
          </div>
          }
          {sectionCoverage &&
          <div className="summary__section">
            <Text value={sectionCoverage.title} className="header__title" component="span"/>
            {chosenPackageName && <Text value={chosenPackageName} component="span"/>}
            <div className="summary__coverage">
              {Object.keys(coverageCodesMerge).map(listItem => {
                return (
                  <div className="summary__coverage-list">
                    <Icon icon="checkmark" fill="black"/>
                    <Coverage variant="name" coverageCode={listItem}/>
                  </div>);
              })}
              {coverageCodes
                .filter(coverage => coverageList[coverage] && !coverageList[coverage].icon
                  && checkConditions(coverageList[coverage].conditions, userData))
                .map((listItem, i, a) => {
                  const summaryClass = classNames(
                    'summary__coverage-list', {
                      'last': i === (a.length - 1
                        && additionalValues.length === 0),
                    }
                  );
                  return (
                    <div className={summaryClass}>
                      <Icon icon="checkmark" fill="black"/>
                      <Coverage variant="name" coverageCode={listItem}/>
                    </div>);
                })}
              {additionalValues
                .map((listItem, i) => {
                  const summaryClass = classNames(
                    'summary__coverage-list',
                    'summary__coverage-list-additional', {
                      'last': i === additionalValues.length - 1,
                    }
                  );

                  return (
                    <div className={summaryClass}>
                      <div>
                        <Icon icon="checkmark" fill="black"/>
                        <Text
                          value={listItem}
                          component="div"
                          className='summary__coverage-list-additionallist'
                        />
                      </div>
                    </div>
                  );
                })}
              {coverageCodes
                .filter(coverage => coverageList[coverage] && coverageList[coverage].icon
                  && checkConditions(coverageList[coverage].conditions, userData))
                .map(coverage => {
                  return (
                    <div className="summary__coverage-list advantage">
                      <Icon icon={coverageList[coverage].icon}/>
                      <Coverage variant="name" coverageCode={coverage}/>
                    </div>);
                })
              }
            </div>
          </div>
          }

          {sectionDateBody &&
          <div className="summary__section summary__header">
            <Text value={sectionDateBody} component="div"/>
          </div>
          }

          {sectionSelectStartDateBody &&
          <div className="summary__header">
            {(sectionSelectStartDateBody.props.map(list => {
              const hidden = list.hidden ? list.hidden : false;
              const showHide = list.showHide ? list.showHide : null;
              const inputParams = {
                ...list,
                ...formParams,
                userData,
                initialValues: { ...initialValues },
                hidden: (stepShowHide(hidden, showHide, userData, {})),
                setFieldValue,
              };
              const InputComponent = stepComponents[list.type];
              return (<InputComponent {...inputParams} />);
            }))}
          </div>
          }

          {sectionValueOfferBody && valueOfferEnable &&
          <div className="summary__section summary__header">
            <Text value={sectionValueOfferBody} component="div"/>
          </div>
          }

          {campaign &&
          <div className="summary__voucher">
            <Icon icon={campaignIcon}/>
            <div className="summary__voucher-info">
              {campaign.map(list => {
                const inputParams = {
                  ...list,
                  ...formParams,
                  initialValues: { ...initialValues },
                };
                const InputComponent = stepComponents[list.type];
                return (
                  <div className='list-item-voucher'><InputComponent {...inputParams} /></div>);
              })}
            </div>
          </div>
          }
        </div>

        {sections &&
        <div className="summary__outer">
          {sections.map(componentProp => {
            const inputParams = {
              'children': sections,
              'columns': calcColumns(componentProp),
              ...componentProp,
              dispatch,
              errors,
              handleSubmit,
              onBlur,
              onChange,
              setFormValues,
              setValues,
              touched,
              values,
              price: userData.price,
              userData,
              initialValues,
            };
            const PriceComponent = stepComponents[componentProp.type];

            return (
              <CSSTransition
                in={componentProp.hidden !== true}
                timeout={300}
                classNames="slideInTop"
                unmountOnExit
              >
                <PriceComponent {...inputParams} />
              </CSSTransition>
            );
          })
          }
        </div>
        }
      </div>
      <div className="grid__col grid__col--12 grid__col--md-4">
        <div className="summary__outer">
          {sectionPrice &&
          <div className="summary__section">
            <Text value={sectionPrice.title} className="leftAlign" component="h5"/>
            {!sectionPrice.hidePrice &&
            <div className="rightAlign">
              <Text
                value={sectionPrice.price}
                className="summary__price"
                component="span"
                numberFormat={true}
              />
              <Text value={sectionPrice.unit} component="span"/>
            </div>
            }
          </div>
          }
          {sectionConsent &&
          (sectionConsent.map(list => {
            const inputParams = {
              ...list,
              ...formParams,
              userData,
              initialValues: { ...initialValues },
            };
            const InputComponent = stepComponents[list.type];
            return (<div className='list-item'><InputComponent {...inputParams} /></div>);
          }))
          }
        </div>
        {sectionsRight &&
        <div className="summary__outer">
          {(sectionsRight.map(list => {
            const inputParams = {
              ...list,
              ...formParams,
              userData,
              initialValues: { ...initialValues },
            };
            const InputComponent = stepComponents[list.type];
            return (<InputComponent {...inputParams} />);
          }))}
        </div>
        }
      </div>
    </div>
  );
};

export default compose(
  connect(state => {
    const {
      section: {
        packageData: {
          translations,
          campaigns,
          initialValues: {
            packageName,
          },
        },
      },
    } = state;
    return {
      translations,
      campaigns,
      packageName,
    };
  })
)(ProductSummary);

ProductSummary.defaultProps = {
  errors: null,
  handleSubmit: null,
  onBlur: null,
  onChange: null,
  setFormValues: null,
  setValues: null,
  touched: null,
  setFieldValue: null,
  userData: null,
  values: null,
  sectionHeader: null,
  sectionContact: null,
  sectionCoverage: null,
  sectionConsent: null,
  sectionPrice: null,
  sectionDate: null,
  sectionSelectStartDate: null,
  sectionValueOffer: null,
  sectionVoucher: null,
  sections: null,
  sectionsRight: null,
  campaigns: null,
};

ProductSummary.propTypes = {
  dispatch: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  setFormValues: PropTypes.func,
  setValues: PropTypes.func,
  touched: PropTypes.object,
  setFieldValue: PropTypes.func,
  userData: PropTypes.object,
  values: PropTypes.object,
  initialValues: PropTypes.object.isRequired,
  sectionHeader: PropTypes.object,
  sectionContact: PropTypes.array,
  sectionCoverage: PropTypes.object,
  sectionConsent: PropTypes.array,
  sectionPrice: PropTypes.object,
  sectionDate: PropTypes.object,
  sectionSelectStartDate: PropTypes.object,
  sectionValueOffer: PropTypes.object,
  sectionVoucher: PropTypes.array,
  sections: PropTypes.array,
  sectionsRight: PropTypes.array,
  translations: PropTypes.object.isRequired,
  campaigns: PropTypes.array,
  packageName: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Steps/General/ProductSummary.jsx